import { create } from 'zustand';
import { supabase } from '../lib/supabase';
import type { Contact } from '../types/contact';

interface ContactStoreState {
  contacts: Contact[];
  loading: boolean;
  error: string | null;
  fetchContacts: () => Promise<void>;
}

function mapNullToUndefined<T extends object>(obj: T): T {
  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [key, value === null ? undefined : value])
  ) as T;
}

export const contactStore = create<ContactStoreState>((set, get) => ({
  contacts: [],
  loading: false,
  error: null,

  fetchContacts: async () => {
    if (get().loading) return;

    set({ loading: true, error: null });
    try {
      // RPC sans paramètres
      const { data, error } = await supabase.rpc('get_user_contacts');
      if (error) throw error;

      // Convertir data (JSON) en tableau de Contact avec null → undefined
      const parsed: Contact[] = (data || []).map((item: Contact) => mapNullToUndefined(item));

      set({ contacts: parsed });
    } catch (err) {
      set({ error: (err as Error).message });
    } finally {
      set({ loading: false });
    }
  },
}));
